<template>
    <div>
        <app-layout>
            <template v-slot:header>
                <Header :title="$t('double_major_app_settings')"
                        :isFilter="false"/>
            </template>
            <template v-slot:header-mobile>
                <HeaderMobile :title="$t('double_major_app_settings')"
                              :isFilter="false"/>
            </template>
            <ValidationObserver ref="settingForm">
                <b-row>
                    <b-col cols="12" md="4">
                        <ValidationProvider name="semester_id" rules="required" v-slot="{errors}">
                            <b-form-group :label="$t('semester')">
                                <semesters-selectbox
                                    :validate-error="errors[0]"
                                    v-model="formData.semester_id">
                                </semesters-selectbox>
                            </b-form-group>
                        </ValidationProvider>
                    </b-col>
                    <b-col cols="12" md="4">
                        <ValidationProvider name="start_date" rules="required" v-slot="{ errors }">
                            <b-form-group :label="$t('start_date')">
                                <b-form-input type="datetime-local" v-model="formData.start_date" :state="errors[0] ? false : null" />
                                <b-form-invalid-feedback v-if="errors[0]" v-html="errors[0]"/>
                            </b-form-group>
                        </ValidationProvider>
                    </b-col>
                    <b-col cols="12" md="4">
                        <ValidationProvider name="end_date" rules="required" v-slot="{ errors }">
                            <b-form-group :label="$t('end_date')">
                                <b-form-input type="datetime-local" v-model="formData.end_date" :state="errors[0] ? false : null" />
                                <b-form-invalid-feedback v-if="errors[0]" v-html="errors[0]"/>
                            </b-form-group>
                        </ValidationProvider>
                    </b-col>
                    <b-col cols="12" md="6">
                        <ValidationProvider name="warning_text_tr" rules="required" v-slot="{ errors }">
                            <b-form-group :label="$t('semester_status_warning_message')+' TR'">
                                <b-form-input type="text" v-model="formData.warning_text_tr" :state="errors[0] ? false : null" />
                                <b-form-invalid-feedback v-if="errors[0]" v-html="errors[0]"/>
                            </b-form-group>
                        </ValidationProvider>
                    </b-col>
                    <b-col cols="12" md="6">
                        <ValidationProvider name="warning_text_en" rules="required" v-slot="{ errors }">
                            <b-form-group :label="$t('semester_status_warning_message')+' EN'">
                                <b-form-input type="text" v-model="formData.warning_text_en" :state="errors[0] ? false : null" />
                                <b-form-invalid-feedback v-if="errors[0]" v-html="errors[0]"/>
                            </b-form-group>
                        </ValidationProvider>
                    </b-col>
                    <b-col cols="12" md="6">
                        <ValidationProvider name="sms_message_tr" rules="required" v-slot="{ errors }">
                            <b-form-group :label="$t('sms_message')+' TR'">
                                <b-form-input type="text" v-model="formData.sms_message_tr" :state="errors[0] ? false : null" />
                                <b-form-invalid-feedback v-if="errors[0]" v-html="errors[0]"/>
                            </b-form-group>
                        </ValidationProvider>
                    </b-col>
                    <b-col cols="12" md="6">
                        <ValidationProvider name="sms_message_en" rules="required" v-slot="{ errors }">
                            <b-form-group :label="$t('sms_message')+' EN'">
                                <b-form-input type="text" v-model="formData.sms_message_en" :state="errors[0] ? false : null" />
                                <b-form-invalid-feedback v-if="errors[0]" v-html="errors[0]"/>
                            </b-form-group>
                        </ValidationProvider>
                    </b-col>
                    <b-col cols="12" md="6">
                        <ValidationProvider name="mail_message_tr" rules="required" v-slot="{errors}">
                            <b-form-group :label="$t('mail_message')+' TR'">
                                <ck-editor-input
                                    :validate-error="errors[0]"
                                    v-model="formData.mail_message_tr" />
                            </b-form-group>
                        </ValidationProvider>
                    </b-col>
                    <b-col cols="12" md="6">
                        <ValidationProvider name="mail_message_en" rules="required" v-slot="{errors}">
                            <b-form-group :label="$t('mail_message')+' EN'">
                                <ck-editor-input
                                    :validate-error="errors[0]"
                                    v-model="formData.mail_message_en" />
                            </b-form-group>
                        </ValidationProvider>
                    </b-col>
                    <b-col cols="12">
                        <b-button variant="primary" @click="saveSettings">{{$t('save')}}</b-button>
                    </b-col>
                    <b-col cols="12" class="d-flex justify-content-between border rounded p-2 mt-4">
                        <b-button variant="secondary" @click="runService('placeResultExcelExport')">{{$t('results')+' EXCEL'}}</b-button>
                        <b-button variant="secondary" @click="runService('placeResultPublish')">{{$t('results_publish')}}</b-button>
                        <b-button variant="secondary" @click="runService('publishResultRegister')">{{$t('registrations_results_publish')}}</b-button>
                        <b-button variant="secondary" @click="runService('addToArchive')">{{$t('make_archive')}}</b-button>
                    </b-col>
                </b-row>
            </ValidationObserver>
        </app-layout>
    </div>
</template>
<script>
// Template
import AppLayout from "@/layouts/AppLayout";
import Header from "@/layouts/AppLayout/Header";
import HeaderMobile from "@/layouts/AppLayout/HeaderMobile";

// Component
import SemestersSelectbox from "@/components/interactive-fields/SemestersSelectbox"
import CkEditorInput from "@/components/elements/CkEditorInput"

// Services
import ConstantService from "@/services/ConstantService"
import SettingsService from "@/services/SettingsService"

// Other
import {ValidationObserver, ValidationProvider} from "vee-validate";
import qs from "qs";

export default {
    components: {
        AppLayout,
        Header,
        HeaderMobile,

        SemestersSelectbox,
        CkEditorInput,

        ValidationProvider,
        ValidationObserver
    },
    data() {
        return {
            formData: {},

        }
    },
    metaInfo() {
        return {
            title: this.$t("double_major_app_settings")
        }
    },
    methods: {
        async getSettings() {
            const config = {
                params: {
                    filter: {
                        key: 'double_major.semester_id,double_major.start_date,double_major.end_date,double_major_minor_semester_status_warning_text_tr,'+
                            'double_major_minor_semester_status_warning_text_en,double_major.registration_sms_message_tr,double_major.registration_sms_message_en,'+
                            'double_major.registration_email_message_tr,double_major.registration_email_message_en'
                    },
                    limit: -1,
                },
                paramsSerializer: (params) => qs.stringify(params, {encode: false}),
            };
            ConstantService.getAll(config).then(response => {
                let data = this.groupBy(response.data.data, 'key')
                this.formData = {
                    semester_id: data['double_major.semester_id'] ? data['double_major.semester_id'][0].value : null,
                    start_date: data['double_major.start_date'] ? data['double_major.start_date'][0].value : null,
                    end_date: data['double_major.end_date'] ? data['double_major.end_date'][0].value : null,
                    warning_text_tr: data['double_major_minor_semester_status_warning_text_tr'] ? data['double_major_minor_semester_status_warning_text_tr'][0].value : null,
                    warning_text_en: data['double_major_minor_semester_status_warning_text_en'] ? data['double_major_minor_semester_status_warning_text_en'][0].value : null,
                    sms_message_tr: data['double_major.registration_sms_message_tr'] ? data['double_major.registration_sms_message_tr'][0].value : null,
                    sms_message_en: data['double_major.registration_sms_message_en'] ? data['double_major.registration_sms_message_en'][0].value : null,
                    mail_message_tr: data['double_major.registration_email_message_tr'] ? data['double_major.registration_email_message_tr'][0].value : null,
                    mail_message_en: data['double_major.registration_email_message_en'] ? data['double_major.registration_email_message_en'][0].value : null
                }
            }).catch(e => {
                this.showErrors(e, null)
            })
        },

        async saveSettings() {
            const isValid = await this.$refs.settingForm.validate();
            if (isValid) {
                ConstantService.updateByKey('double_major.semester_id', {value: this.formData.semester_id, type: 'semester'}).catch(e => {
                    this.showErrors(e, null)
                })
                ConstantService.updateByKey('double_major.start_date', {value: this.formData.start_date, type: 'date'}).catch(e => {
                    this.showErrors(e, null)
                })
                ConstantService.updateByKey('double_major.end_date', {value: this.formData.end_date, type: 'date'}).catch(e => {
                    this.showErrors(e, null)
                })
                ConstantService.updateByKey('double_major_minor_semester_status_warning_text_tr', {value: this.formData.warning_text_tr, type: 'string'}).catch(e => {
                    this.showErrors(e, null)
                })
                ConstantService.updateByKey('double_major_minor_semester_status_warning_text_en', {value: this.formData.warning_text_en, type: 'string'}).catch(e => {
                    this.showErrors(e, null)
                })
                ConstantService.updateByKey('double_major.registration_sms_message_tr', {value: this.formData.sms_message_tr, type: 'string'}).catch(e => {
                    this.showErrors(e, null)
                })
                ConstantService.updateByKey('double_major.registration_sms_message_en', {value: this.formData.sms_message_en, type: 'string'}).catch(e => {
                    this.showErrors(e, null)
                })
                ConstantService.updateByKey('double_major.registration_email_message_tr', {value: this.formData.mail_message_tr, type: 'html'}).catch(e => {
                    this.showErrors(e, null)
                })
                ConstantService.updateByKey('double_major.registration_email_message_en', {value: this.formData.mail_message_en, type: 'html'}).catch(e => {
                    this.showErrors(e, null)
                })
                this.$toast.success(this.$t('proccess_success'))
            }
        },

        runService(service) {
            SettingsService[service]().then(response => {
                if(service == 'placeResultExcelExport'){
                    this.$toast.success(this.$t('proccess_success'))
                    this._downloadFile(response, 'placeResultExcelExport.xlsx')
                } else {
                    this.$toast.success(this.$t('api.'+response.data.message))
                }
            }).catch(e => {
                this.showErrors(e, null)
            })
        }
    },
    created() {
        this.getSettings()
    }
}
</script>
